import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  root: {
    height: theme.props.contentHeight,
    margin: "0 -16px",
    alignContent: "flex-start",
  },
  
}));

export default useStyle;
